/**
 * DESIGN: 赤钢工业线 — metadata stays factual, product-led and free of unsupported performance or certification claims.
 */
import { useEffect } from "react";
import { publicUrl } from "@/lib/seo";
import { resolveSsrRouteSeo } from "@/ssr/routeSeo";

function upsertMeta(attribute: "name" | "property", key: string, content: string) {
  let node = document.querySelector(`meta[${attribute}="${key}"]`);
  if (!node) {
    node = document.createElement("meta");
    node.setAttribute(attribute, key);
    document.head.appendChild(node);
  }
  node.setAttribute("content", content);
}

function syncRouteBreadcrumb(pathname: string) {
  const breadcrumb = resolveSsrRouteSeo(pathname).jsonLd.find((schema) => schema["@type"] === "BreadcrumbList");
  if (!breadcrumb) return;

  let node = document.querySelector<HTMLScriptElement>('script[data-route-seo="breadcrumb"]');
  if (!node) {
    node = document.createElement("script");
    node.type = "application/ld+json";
    node.dataset.routeSeo = "breadcrumb";
    document.head.appendChild(node);
  }
  node.textContent = JSON.stringify(breadcrumb).replace(/</g, "\\u003c");
}

export default function PageMeta({ title, description }: { title: string; description: string }) {
  useEffect(() => {
    document.title = title;
    let descriptionNode = document.querySelector('meta[name="description"]');
    if (!descriptionNode) {
      descriptionNode = document.createElement("meta");
      descriptionNode.setAttribute("name", "description");
      document.head.appendChild(descriptionNode);
    }
    descriptionNode.setAttribute("content", description);
    upsertMeta("property", "og:title", title);
    upsertMeta("property", "og:description", description);
    upsertMeta("property", "og:url", publicUrl(window.location.pathname));
    upsertMeta("name", "twitter:title", title);
    upsertMeta("name", "twitter:description", description);
    let canonicalNode = document.querySelector('link[rel="canonical"]') as HTMLLinkElement | null;
    if (!canonicalNode) {
      canonicalNode = document.createElement("link");
      canonicalNode.setAttribute("rel", "canonical");
      document.head.appendChild(canonicalNode);
    }
    canonicalNode.href = publicUrl(window.location.pathname);
    syncRouteBreadcrumb(window.location.pathname);
  }, [title, description]);
  return null;
}
